import { Fragment } from "react";
import ComponentHeading from "../../../../widgets/ComponentHeading";
import { PiChalkboardTeacherThin } from "react-icons/pi";
import AppURL from "../../../../widgets/AppURL";

const IDCardPrintView = ({ onEmployeeList, setSelectedRows, selectedRows }) => {
  const handleCheckboxChange = (id) => {
    setSelectedRows((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = onEmployeeList?.data?.map((item) => item.member_sn) || [];
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };
  return (
    <Fragment>
      <ComponentHeading icon={PiChalkboardTeacherThin} label={"Teacher List"} />
      <div className="relative overflow-x-auto overflow-y-auto h-[80vh]">
        <table className="text-sm text-left rtl:text-right text-slate100 whitespace-nowrap scroll-x-auto dark:text-slate400 rounded w-full">
          <thead className="text-[11px] text-slate700 capitalize border-b dark:text-slate400 font-public-sans">
            <tr className="top-0 z-50 sticky">
              <th
                scope="col"
                align="center"
                className="px-2 py-1 border dark:border-slate600 w-10 bg-slate200 dark:bg-slate900"
              >
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={
                    selectedRows?.length === onEmployeeList?.data?.length &&
                    onEmployeeList?.data?.length > 0
                  }
                />
              </th>
              <th
                scope="col"
                align="center"
                className="px-2 py-1 border dark:border-slate600 w-10 bg-slate200 dark:bg-slate900"
              >
                {"S.N."}
              </th>
              <th
                scope="col"
                className="px-2 py-1 border dark:border-slate600 bg-slate200 dark:bg-slate900"
              >
                {"Emp. Name"}
              </th>
              <th
                scope="col"
                className="px-2 py-1 border dark:border-slate600 bg-slate200 dark:bg-slate900"
              >
                {"Citizenship No."}
              </th>
              <th
                scope="col"
                className="px-2 py-1 border dark:border-slate600 bg-slate200 dark:bg-slate900"
              >
                {"Gender"}
              </th>
              <th
                scope="col"
                className="px-2 py-1 border dark:border-slate600 bg-slate200 dark:bg-slate900"
              >
                {"Qualification"}
              </th>
              <th
                scope="col"
                className="px-2 py-1 border dark:border-slate600 bg-slate200 dark:bg-slate900"
              >
                {"Types of Service (Full Time/Part Time)"}
              </th>
              <th
                scope="col"
                className="px-2 py-1 border dark:border-slate600 bg-slate200 dark:bg-slate900"
              >
                {"Subject"}
              </th>
              <th
                scope="col"
                className="px-2 py-1 border dark:border-slate600 bg-slate200 dark:bg-slate900"
              >
                {"Faculty"}
              </th>
              <th
                scope="col"
                className="px-2 py-1 border dark:border-slate600 bg-slate200 dark:bg-slate900"
              >
                {"No. of Hours Teach"}
              </th>
            </tr>
          </thead>
          <tbody className="text-slate-800">
            {Array.isArray(onEmployeeList?.data) &&
              onEmployeeList?.data?.map((item, index) => (
                <tr
                  key={index}
                  className="odd:bg-white text-[11px] text-slate700 dark:text-slate400 odd:dark:bg-slate800 even:bg-slate100 even:dark:bg-slate700 border-b font-public-sans dark:border-slate700"
                >
                  <td
                    align="center"
                    className="px-2 border dark:border-slate600 py-1"
                  >
                    <input
                      type="checkbox"
                      checked={selectedRows?.includes(item?.member_sn)}
                      onChange={() => handleCheckboxChange(item?.member_sn)}
                    />
                  </td>
                  <td
                    align="center"
                    className="px-2 border dark:border-slate600 py-1"
                  >
                    {index + 1}.
                  </td>
                  <td className="px-2 border dark:border-slate600 capitalize">
                    <div className="flex gap-2">
                      <img
                        className="w-5 h-5 rounded-full"
                        src={`${AppURL.BaseURL + item?.photo}`}
                        alt=""
                      />{" "}
                      <span>{`${item?.first_name || ""} ${
                        item.middle_name || ""
                      }  ${item.last_name || "" }`}</span>
                    </div>
                  </td>
                  <td
                    align="left"
                    className="px-2 border dark:border-slate600 "
                  >
                    {item?.citiz_no}
                  </td>
                  <td
                    align="left"
                    className="px-2 border dark:border-slate600 "
                  >
                    {parseInt(item?.gender) === 1 ? "Male" : "Female"}
                  </td>
                  <td
                    align="left"
                    className="px-2 border dark:border-slate600 "
                  >
                    {item?.qualification}
                  </td>
                  <td
                    align="left"
                    className="px-2 border dark:border-slate600 "
                  >
                    {parseInt(item?.part_full) === 1
                      ? "Part Time"
                      : "Full Time"}
                  </td>
                  <td
                    align="left"
                    className="px-2 border dark:border-slate600 "
                  >
                    {item?.subj}
                  </td>
                  <td className="px-2 border dark:border-slate600 ">
                    {item?.faculty}
                  </td>
                  <td className="px-2 border dark:border-slate600 ">
                    {item?.no_of_teach_hr}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {/* You can use the selectedRows state for further operations */}
      {/* For example: */}
      {/* <div>Selected IDs: {selectedRows.join(', ')}</div> */}
    </Fragment>
  );
};

export default IDCardPrintView;
